import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Films from "./pages/Films";
import Contact from "./pages/Contact";
import Pitch from "./pages/Pitch";
import LoadingScreen from "./components/LoadingScreen";

export default function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const images = document.images;
    let loadedCount = 0;

    if (images.length === 0) {
      setLoading(false);
      return;
    }

    Array.from(images).forEach((img) => {
      if (img.complete) {
        loadedCount++;
        if (loadedCount === images.length) setLoading(false);
      } else {
        img.addEventListener("load", () => {
          loadedCount++;
          if (loadedCount === images.length) setLoading(false);
        });
        img.addEventListener("error", () => {
          loadedCount++;
          if (loadedCount === images.length) setLoading(false);
        });
      }
    });
  }, []);

  return (
    <>
      {loading && <LoadingScreen />}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="films" element={<Films />} />
            <Route path="contact" element={<Contact />} />
            <Route path="pitch" element={<Pitch />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}